import {environment} from '../../../environments/environment';

const initial = environment.apiErrors?.customHandledStatuses ?? [];
const customHandledStatusCodes = new Set<number>(initial);

export function registerCustomHandledStatuses(...codes: number[]): void {
  for (const code of codes) {
    if (Number.isFinite(code)) customHandledStatusCodes.add(code);
  }
}

export function isCustomHandledStatus(code: number | undefined | null): boolean {
  return typeof code === 'number' && customHandledStatusCodes.has(code);
}
